import { render } from "./PaymentHistoy.vue?vue&type=template&id=5af6cfce&scoped=true"
import script from "./PaymentHistoy.vue?vue&type=script&lang=js"
export * from "./PaymentHistoy.vue?vue&type=script&lang=js"

import "./PaymentHistoy.vue?vue&type=style&index=0&id=5af6cfce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af6cfce"]])

export default __exports__